import { Button } from 'common/components';

const NewOrderButton = ({ size = 'large', onClick, to }) => (
  <Button size={size} onClick={onClick} to={to}>
    Start a New Order
  </Button>
);

export default NewOrderButton;
